"use client";
import React, { useState } from "react";

const DownArrowIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      d="M12.854 9.35375L8.35403 13.8538C8.30759 13.9002 8.25245 13.9371 8.19175 13.9623C8.13105 13.9874 8.06599 14.0004 8.00028 14.0004C7.93457 14.0004 7.86951 13.9874 7.80881 13.9623C7.74811 13.9371 7.69296 13.9002 7.64653 13.8538L3.14653 9.35375C3.05271 9.25993 3 9.13268 3 9C3 8.86732 3.05271 8.74007 3.14653 8.64625C3.24035 8.55243 3.3676 8.49972 3.50028 8.49972C3.63296 8.49972 3.76021 8.55243 3.85403 8.64625L7.50028 12.2931V2.5C7.50028 2.36739 7.55296 2.24021 7.64672 2.14645C7.74049 2.05268 7.86767 2 8.00028 2C8.13289 2 8.26006 2.05268 8.35383 2.14645C8.4476 2.24021 8.50028 2.36739 8.50028 2.5V12.2931L12.1465 8.64625C12.2403 8.55243 12.3676 8.49972 12.5003 8.49972C12.633 8.49972 12.7602 8.55243 12.854 8.64625C12.9478 8.74007 13.0006 8.86732 13.0006 9C13.0006 9.13268 12.9478 9.25993 12.854 9.35375Z"
      fill="#3399FF"
    />
  </svg>
);
const faqItems = [
  {
    value: "faq-1",
    question: " Am I eligible for the CPA course in Delhi after a B.Com?",
    answer:
      "Most B.Com and commerce graduates meet the base credit requirement. Depending on your university and the state board you choose, Miles evaluates your transcript and builds a bridge course plan, typically 30 credits, to close any gap.",
  },
  {
    value: "faq-2",
    question: "What are the CPA Course Fees?",
    answer: (
      <>
        Miles Education{" "}
        <a
          href="https://www.mileseducation.com/cpa/cpa-fees"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#39F] underline"
        >
          CPA fees
        </a>{" "}
        cover the coaching package, roughly ₹99,000 + GST. Credential evaluation
        (~₹34,400) and exam fees (~$873 per section) are paid separately.
        All-in, total cost typically falls in the ₹3.8–4.5 lakh range.
      </>
    ),
  },
  {
    value: "faq-3",
    question: "What should I look for in the best CPA coaching in Delhi?",
    answer: (
      <>
        Look for structured mentorship, a clear plan across all four exam
        sections, and credential-evaluation support, not just recorded lectures.
        Miles CPA coaching in Delhi includes live classes and a study plan built
        around your schedule, which is what most students comparing the{" "}
        <a
          href="https://www.mileseducation.com/cpa/miles-cpa"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#39F] underline"
        >
          best institute for CPA
        </a>{" "}
        in Delhi are really weighing.
      </>
    ),
  },
  {
    value: "faq-4",
    question: "How many exams do I need to clear, and in what time?",
    answer:
      "CPA has 4 exams total: 3 Core exams (FAR, AUD, REG) and 1 Discipline exam of your choice (BAR, ISC, or TCP). Most Miles students complete all 4 within 12–18 months.",
  },
  {
    value: "faq-5",
    question: "Can I take the CPA exam in Delhi itself?",
    answer: (
      <>
        Yes. Delhi NCR is one of the official Prometric test center regions in
        India for the{" "}
        <a
          href="https://www.mileseducation.com/cpa/cpa-exam"
          target="_blank"
          rel="noopener noreferrer"
          className="text-[#39F] underline"
        >
          CPA exam
        </a>
        .
      </>
    ),
  },
  {
    value: "faq-6",
    question: "What does a CPA in Delhi typically earn?",
    answer:
      "CPAs in India typically earn ₹10–20 lakhs annually, and CPAs working in the U.S. can earn $60,000+ annually.",
  },
];

const Cpa_Delhi_FAQ = () => {
  const [showAllFaqs, setShowAllFaqs] = useState(false);
  const [expandedItems, setExpandedItems] = useState<Set<string>>(new Set());

  const toggleExpand = (value: string) => {
    setExpandedItems((prev) => {
      const next = new Set(prev);
      if (next.has(value)) next.delete(value);
      else next.add(value);
      return next;
    });
  };

  const visibleItems = showAllFaqs ? faqItems : faqItems.slice(0, 3);
  return (
    <section className="w-full bg-[#F5F5F5] pt-3 pb-6 md:bg-white md:py-12">
      <div className="main_container">
        <div className="rounded-2xl bg-white p-4 shadow-sm md:rounded-none md:p-0 md:shadow-none">
          <h2 className="text-center text-[22px] font-bold tracking-[-1.76px] text-[#061A2F] md:text-[32px]">
            FAQS
          </h2>

          <div className="mx-auto mt-6 max-w-[820px] md:mt-8">
            {visibleItems.map((item) => {
              const isExpanded = expandedItems.has(item.value);
              return (
                <div
                  key={item.value}
                  className="mb-4 flex flex-col gap-2.5 rounded-2xl bg-[#F7FBFF] p-4"
                >
                  <div className="w-full text-left text-sm font-bold leading-normal text-[#333] md:text-base">
                    {item.question}
                  </div>
                  <div
                    className={`relative text-xs font-normal leading-normal text-[#999] md:text-sm ${
                      isExpanded ? "" : "max-h-[60px] overflow-hidden"
                    }`}
                  >
                    {item.answer}
                    {!isExpanded && (
                      <div className="pointer-events-none absolute bottom-0 left-0 right-0 h-8 bg-gradient-to-t from-[#F7FBFF] to-transparent" />
                    )}
                  </div>
                  <button
                    type="button"
                    onClick={() => toggleExpand(item.value)}
                    className="inline-flex items-center gap-1 self-start border-0 bg-transparent p-0 text-xs font-bold text-[#39f] md:text-sm"
                  >
                    {isExpanded ? "Read Less" : "Read More"}
                    <span
                      className="inline-flex transition-transform duration-200"
                      style={{
                        transform: isExpanded ? "rotate(180deg)" : "none",
                      }}
                    >
                      <DownArrowIcon />
                    </span>
                  </button>
                </div>
              );
            })}

            {faqItems.length > 3 && (
              <button
                type="button"
                className="mx-auto mt-4 flex w-full items-center justify-center gap-1 border-0 bg-transparent p-0 text-sm font-bold text-[#39f]"
                onClick={() => setShowAllFaqs(!showAllFaqs)}
              >
                {showAllFaqs ? "See Less" : "See More"}
                <span
                  className="inline-flex transition-transform duration-200"
                  style={{ transform: showAllFaqs ? "rotate(180deg)" : "none" }}
                >
                  <DownArrowIcon />
                </span>
              </button>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Cpa_Delhi_FAQ;
